'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'megaphone';
var width = 512;
var height = 512;
var aliases = [128227];
var unicode = 'f675';
var svgPathData = ['M64 198.6l0 114.8 384 108 0-330.8-384 108z', 'M464 48l0 416 32 0 0-416-32 0zM448 32l64 0 0 448-64 0 0-42-129.6-36.5c-8.2 44.6-47.4 78.5-94.4 78.5-53 0-96-43-96-96 0-12.1 2.2-23.6 6.3-34.2l-70.3-19.8 0 22-64 0 0-192 64 0 0 22 384-108 0-42zm0 58.6l-384 108 0 114.8 384 108 0-330.8zM149.8 354.1c-3.7 9.2-5.8 19.3-5.8 29.9 0 44.2 35.8 80 80 80 39.7 0 72.6-28.9 78.9-66.8L149.8 354.1zM48 176l-32 0 0 160 32 0 0-160z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMegaphone = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;